// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SpPZA","text":"styles_text__m4cJg"};